/* eslint-disable max-len */
import React, { useState } from 'react';
import { Text, Pane, Flex, Button, PortalOverlay, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
// import I18N from '@leverege/i18n'
import classes from './RejectTransferClasses.css';

// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RejectTransferView(props) {
  const {
    onClose,
    parentIncomingTransfer,
    reloadData
  } = props;
  const incomingTransferId = parentIncomingTransfer?.id;
  const systemId = parentIncomingTransfer.systemId;
  const parentOutgoingTransferId = parentIncomingTransfer.data?.pairedTransferId;
  const transferredDevicesAlias = parentIncomingTransfer.data?.transferredDevicesAlias;
  const [loading, setLoading] = useState();

  // const uiName = process.env.UI_NAME
  // const assetIndustryName = t( `assetIndustryName.${uiName}`, 'Asset' )

  const onReject = evt => {
    try {
      setLoading(true);
      GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => {
        try {
          const res = await api.system(systemId).device(incomingTransferId).srv('ownershipTransfer').post('rejectBulkTransfer', {
            parentOutgoingTransferId,
            deviceAlias: transferredDevicesAlias
          });
          if (res.status !== 500) {
            setTimeout(async () => {
              await reloadData();
            }, 2000);
            Toast.success('Transfer rejected');
          } else {
            Toast.error('Error rejecting Transfer');
          }
        } catch (error) {
          Toast.error('Error rejecting Transfer');
        }
      });
    } catch (error) {
      Toast.error('Error rejecting Transfer');
    } finally {
      onClose(evt);
    }
  };
  const iconBackgroundStyle = {
    height: '24px',
    width: '24px',
    borderRadius: '2px',
    backgroundColor: '#F0F6FF',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  const iconStyle = {
    color: '#1646C5',
    position: 'absolute',
    align: 'center'
  };
  const renderDialog = () => /*#__PURE__*/_jsxs(Pane, {
    variant: "editorDialog",
    className: classes.dialog,
    children: [/*#__PURE__*/_jsxs(Flex, {
      className: classes.dialogHeader,
      justify: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        style: {
          fontWeight: 'bold'
        },
        icon: /*#__PURE__*/_jsx(Flex, {
          style: {
            ...iconBackgroundStyle
          },
          children: /*#__PURE__*/_jsx("img", {
            style: {
              ...iconStyle
            },
            alt: "Transfer Icon",
            src: "https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-transfers-blue.svg"
          })
        }),
        children: "Reject Transfer"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeWindow",
        icon: "fa fa-remove",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      style: {
        overflow: 'hidden'
      },
      className: classes.dialogBody,
      children: /*#__PURE__*/_jsx(Text, {
        className: classes.dialogBodyText,
        children: "Rejecting this transfer prevents access to the transferred items and returns them to the seller's inventory. This cannot be undone."
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      className: classes.dialogFooter,
      justify: "flex-end",
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        className: classes.cancelButton,
        onClick: onClose,
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primaryDestructive",
        disabled: loading,
        onClick: onReject,
        children: " Reject Transfer "
      })]
    })]
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: true,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: renderDialog()
  });
}